import { render, staticRenderFns } from "./HealthyLife.vue?vue&type=template&id=c0bb0d42&scoped=true&"
import script from "./HealthyLife.vue?vue&type=script&lang=js&"
export * from "./HealthyLife.vue?vue&type=script&lang=js&"
import style0 from "./HealthyLife.vue?vue&type=style&index=0&id=c0bb0d42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bb0d42",
  null
  
)

export default component.exports